/* eslint-disable max-len */
import React from 'react';
import Form from 'screens/shared/form';
import { actions } from 'redux/local';
import { VALIDATION } from 'constant';
import { isEmptyArray, _t } from 'utils';
import { formField } from 'types';
import { useSelector } from 'react-redux';
import { ACTIONS_TYPES } from 'redux/helper';

export default ({
  isCancel = false, onCancel, item = {}, dcId,
}) => {
  const { [ACTIONS_TYPES.DATA_CENTER.GET]: datacenter } = useSelector((e) => e);
  const { id, ...editProps } = item;

  const isLanPublic = (lanId) => (datacenter?.entities?.lans?.items || [])?.find((e) => e.id === lanId)?.properties?.public;

  const model = {
    name: '', ips: [], lbPrivateIps: [], ...editProps,
  };

  const ipsHelpText = 'Collection of IP addresses of the Application Load Balancer. (inbound and outbound) IP of the listenerLan must be a customer reserved IP for the public load balancer and private IP for the private load balancer.';
  const privateIpsHelpText = 'Collection of private IP addresses with subnet mask of the Application Load Balancer. IPs must contain valid subnet mask. If you do not provide any IP then the system will generate one IP with /24 subnet.';

  const fields = [
    formField.text({ name: 'name', title: _t('Name') }),
    formField.lan({ name: 'listenerLan', title: 'Listener Lan', hasNewOption: false }),
    formField.ips({
      name: 'ips', title: 'Listener IPs', helpText: ipsHelpText, updateProps: (e) => ({ privateOnly: !isLanPublic(e?.listenerLan) }),
    }),
    formField.lan({
      name: 'targetLan', title: 'Target Lan', hasNewOption: false, privateOnly: true,
    }),
    formField.ips({
      name: 'lbPrivateIps', title: 'Load Balancer Private IPs', privateOnly: true, helpText: privateIpsHelpText,
    }),
  ];

  const validations = [
    { name: 'name', type: VALIDATION.REQUIRED },
    { name: 'name', type: VALIDATION.STRING, max: 255 },
    { name: 'ips', type: VALIDATION.REQUIRED },
    { name: 'listenerLan', type: VALIDATION.REQUIRED },
    { name: 'targetLan', type: VALIDATION.REQUIRED },
  ];

  const onSave = (properties) => {
    // eslint-disable-next-line no-unreachable
    const { listenerLan: ll, targetLan: tl, lbPrivateIps: lbIPs = [] } = properties;
    if (ll === tl) return alert('The listener LAN & target LAN should be different!');
    if (isEmptyArray(lbIPs)) delete properties.lbPrivateIps;
    if (id) return actions.applicationLoadbalancer.update({ dcId, id, properties });
    return actions.applicationLoadbalancer.create({ dcId, properties });
  };

  return (
    <Form
      fields={fields}
      fieldsValues={model}
      onSubmit={onSave}
      isCancel={isCancel}
      onCancel={onCancel}
      validations={validations}
    />
  );
};
